// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1t3X3","item":"PaymentsMobile_item__2IGpV","label":"PaymentsMobile_label__WAO_x","amount":"PaymentsMobile_amount__2WqIC"};